import { TwoFactorTypes } from "./TwoFactorTypes";

enum ResponseType {
    Success = "Success",
    IncorrectUsernamePassword = "IncorrectUsernamePassword",
    AccountDeactivated = "AccountDeactivated",
    NoSystemAccess = "NoSystemAccess",
    Unset = "Unset",
    Timeout = "Timeout",
    Locked = "Locked",
    TwoFactorRequired = "TwoFactorRequired",
    TwoFactorIncorrect = "TwoFactorIncorrect",
    NoValidSubscription = "NoValidSubscription",
    ResetPassword = "ResetPassword",
    AddSecondFactor = "AddSecondFactor",
    DatabaseMigration = "DatabaseMigration",
}

interface AuthenticationResponse {
    sessionIdentifier: string;
    authenticationIdentifier: string;
    response: ResponseType;
    twoFactorType: TwoFactorTypes;
    isAdmin: boolean;
    isSystemAdmin: boolean;
}

export { AuthenticationResponse, ResponseType };
